var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPluginNasaEarthAirAndWaterIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero",
  stroke: "none"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  x: 0,
  y: 0
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M3.932 12.132c.395.561.886 1.05 1.449 1.442l-2.1 2.1-1.432-1.459zm-.984-4.405a5.9 5.9 0 0 0 .001 2.046H0V7.727zm9.203-3.782 2.065-2.12 1.435 1.46-2.085 2.084a5.9 5.9 0 0 0-1.415-1.424M3.285 1.849l2.079 2.079A5.9 5.9 0 0 0 3.94 5.345L1.824 3.284zM9.773 0v2.95a5.9 5.9 0 0 0-2.046-.002V0zM8.745 3.86c1.814 0 3.397.989 4.24 2.457q-.653.17-1.274.438a9.4 9.4 0 0 0-2.96 1.997 9.44 9.44 0 0 0-2.436 4.232 4.885 4.885 0 0 1 2.43-9.124"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7F700",
  d: "M8.745 5.86c.962 0 1.814.47 2.338 1.195a9.3 9.3 0 0 0-4.03 4.026A2.885 2.885 0 0 1 8.745 5.86"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M15.38 7.76q1.58 0 2.975.602 1.386.598 2.416 1.627a7.7 7.7 0 0 1 1.627 2.416Q23 13.8 23 15.38t-.602 2.975a7.7 7.7 0 0 1-1.627 2.416 7.7 7.7 0 0 1-2.416 1.627A7.4 7.4 0 0 1 15.38 23q-1.58 0-2.975-.602a7.7 7.7 0 0 1-2.416-1.627 7.7 7.7 0 0 1-1.627-2.416 7.4 7.4 0 0 1-.602-2.975q0-1.58.602-2.975a7.7 7.7 0 0 1 1.627-2.416 7.7 7.7 0 0 1 2.416-1.627 7.4 7.4 0 0 1 2.975-.602"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M14.677 20.97v-1.371q-.58 0-.993-.413a1.35 1.35 0 0 1-.413-.994v-.703l-3.375-3.375q-.054.316-.097.633-.044.316-.044.633a5.5 5.5 0 0 0 1.397 3.727q1.398 1.599 3.525 1.863m4.851-1.793a5.62 5.62 0 0 0 1.477-3.797q0-1.722-.958-3.146a5.4 5.4 0 0 0-2.558-2.057v.281q0 .58-.413.993a1.35 1.35 0 0 1-.993.413h-1.406v1.407a.68.68 0 0 1-.202.5.68.68 0 0 1-.501.203h-1.406v1.406h4.218q.3 0 .501.202a.68.68 0 0 1 .202.501v2.11h.703q.457 0 .827.272.369.273.51.712"
}))));
export default SvgPluginNasaEarthAirAndWaterIcon;